import React from 'react';
import { MapPin } from 'lucide-react';
import { franchises } from '../data/mock';

const Franchises = () => {
  return (
    <section id="franchises" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        {/* Section header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-primary font-semibold text-sm uppercase tracking-wider">
            Notre Présence
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-6">
            Une couverture régionale unique
          </h2>
          <p className="text-xl text-gray-600">
            SESAM est présent dans 3 pays d'Afrique centrale et de l'ouest pour servir vos campagnes multi-pays
          </p>
        </div>

        {/* Map visual representation */}
        <div className="max-w-5xl mx-auto mb-16">
          <div className="bg-gradient-to-br from-primary/5 to-cyan-50 rounded-3xl p-8 lg:p-12">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {franchises.map((franchise) => (
                <div
                  key={franchise.id}
                  className={`group relative bg-white rounded-xl p-6 transition-all duration-300 hover:shadow-xl hover:-translate-y-2 ${
                    franchise.headquarters 
                      ? 'border-2 border-primary shadow-lg' 
                      : 'border border-gray-200'
                  }`}
                >
                  {franchise.headquarters && (
                    <div className="absolute -top-3 left-1/2 transform -translate-x-1/2">
                      <span className="bg-primary text-white text-xs font-bold px-3 py-1 rounded-full">
                        Siège Social
                      </span>
                    </div>
                  )}

                  <div className="text-center space-y-4">
                    <div className="text-5xl">{franchise.flag}</div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-1">
                        {franchise.country}
                      </h3>
                      <div className="flex items-center justify-center gap-2 text-gray-600">
                        <MapPin size={16} aria-hidden="true" />
                        <span>{franchise.city}</span>
                      </div>
                    </div>
                    <div className={`w-12 h-1 mx-auto rounded-full ${
                      franchise.headquarters ? 'bg-primary' : 'bg-cyan-300'
                    }`}></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Coverage highlights */}
        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          <div className="text-center space-y-3">
            <div className="bg-gradient-to-br from-primary to-cyan-600 text-white w-16 h-16 rounded-2xl flex items-center justify-center mx-auto text-2xl font-bold">
              3
            </div>
            <h4 className="text-xl font-bold text-gray-900">Pays couverts</h4>
            <p className="text-gray-600">Une présence stratégique en Afrique</p>
          </div>
          <div className="text-center space-y-3">
            <div className="bg-gradient-to-br from-cyan-500 to-blue-600 text-white w-16 h-16 rounded-2xl flex items-center justify-center mx-auto text-2xl font-bold">
              10+
            </div>
            <h4 className="text-xl font-bold text-gray-900">Villes majeures</h4>
            <p className="text-gray-600">Des emplacements premium</p>
          </div>
          <div className="text-center space-y-3">
            <div className="bg-gradient-to-br from-blue-500 to-primary text-white w-16 h-16 rounded-2xl flex items-center justify-center mx-auto text-2xl font-bold">
              24/7
            </div>
            <h4 className="text-xl font-bold text-gray-900">Support actif</h4>
            <p className="text-gray-600">Assistance dans tous les pays</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Franchises;
